import { render, staticRenderFns } from "./CartTotalEntries.vue?vue&type=template&id=779e42ce&scoped=true"
import script from "./CartTotalEntries.vue?vue&type=script&lang=ts"
export * from "./CartTotalEntries.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779e42ce",
  null
  
)

export default component.exports